import { render, staticRenderFns } from "./SchoolSettings.vue?vue&type=template&id=c143aad4&scoped=true&"
import script from "./SchoolSettings.vue?vue&type=script&lang=js&"
export * from "./SchoolSettings.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSettings.vue?vue&type=style&index=0&id=c143aad4&prod&scoped=true&lang=css&"
import style1 from "./SchoolSettings.vue?vue&type=style&index=1&id=c143aad4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c143aad4",
  null
  
)

export default component.exports